module.exports = __webpack_public_path__ + "img/SketchPngf1b0e83386d6b9dec32550a78097be6598ea11c77e19fb6b7ecd8a76c86a1866.203f14b1.png";